import http from './http'

/**
 * 类似群组数据，与同行端 mobile.php / sub_classify 一致
 */
export function fetchSubClassify() {
  return http.get('/mobile.php').then(result => {
    if (result.status !== 1 || !result.data) {
      return []
    }
    return result.data.sub_classify || []
  })
}
